import PropTypes from "prop-types";

function Deferred({ size = 25, color = "black" }) {
  return (
    <svg
      width={size}
      height={size}
      className={color}
      viewBox="0 0 330 330"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill={color}
        d="M295,300h-25v-36.566c0-3.265-0.135-6.511-0.382-9.734c-0.009-0.096-0.011-0.194-0.021-0.29
  c-2.732-34.635-19.506-66.523-46.064-88.408c26.534-21.867,43.304-53.719,46.058-88.318c0.028-0.253,0.039-0.511,0.054-0.768
  c0.228-3.097,0.355-6.212,0.355-9.347V30h25c8.284,0,15-6.716,15-15s-6.716-15-15-15h-40H75H35c-8.284,0-15,6.716-15,15
  s6.716,15,15,15h25v36.568c0,3.3,0.137,6.579,0.39,9.836c0.005,0.053,0.005,0.107,0.011,0.16
  c2.726,34.645,19.502,66.545,46.066,88.437c-26.541,21.87-43.31,53.73-46.06,88.337c-0.023,0.216-0.031,0.436-0.046,0.654
  C60.129,257.12,60,260.268,60,263.434V300H35c-8.284,0-15,6.716-15,15s6.716,15,15,15h40h180h40c8.284,0,15-6.716,15-15
  S303.284,300,295,300z M240,30v30H90V30H240z M140.284,178.119c4.767-2.644,7.724-7.666,7.724-13.117
  c0-5.451-2.957-10.473-7.724-13.118C116.273,138.565,99.312,115.962,92.871,90h144.258c-6.44,25.962-23.402,48.565-47.413,61.885
  c-4.767,2.645-7.724,7.667-7.724,13.118c0,5.451,2.957,10.473,7.724,13.117c24.011,13.318,40.972,35.92,47.413,61.881H92.871
  C99.313,214.039,116.273,191.438,140.284,178.119z M90,300v-30h150v30H90z"
      />
    </svg>
  );
}

Deferred.propTypes = {
  size: PropTypes.number,
  color: PropTypes.string
};

export default Deferred;
